import { render } from "./RecentOrders.vue?vue&type=template&id=1b263b1f&ts=true"
import script from "./RecentOrders.vue?vue&type=script&lang=ts"
export * from "./RecentOrders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__